// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Component Styles */
.scl--web-component-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100vh;
  max-height: 500px;
  margin: 0 auto;
  background: #000000;
  overflow: hidden;
  box-sizing: border-box;
} 


/* Override CareerGradient positioning for footer use */
.scl--web-component-footer .scl--svg-gradient-care {
  position: absolute;
  top: -1px;
  bottom: -100px; 
  left: 0;
  width: 100%;
  height: calc(100% + 101px);
  min-height: auto;
  z-index: 0
}

.scl--web-component-footer .scl--svg-gradient-care__bg {
  filter: blur(10px);
  /* Mask the edges */
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 5%,
    black 95%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 5%,
    black 95%,
    transparent 100%
  );
}
.scl--web-component-footer .scl--svg-gradient-care::after {
  background:
    radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.2) 10%
    ),
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.199) 0%,
      rgba(18, 8, 6, 0.45) 38%,
      rgba(14, 6, 4, 0.75) 58%,
      rgba(8, 3, 2, 0.92) 78%,
      rgba(0, 0, 0, 0.98) 100%
    );
}
/* Main content container */
.scl--web-component-footer-content {
  display: flex;
  justify-content: end;
  align-items: end;
  position: relative;
  max-width: var(--global-desktop-width-resp);
  width: 100%;
  height: 100%;
  padding: 150px var(--global-desktop-padding-left) 50px var(--global-desktop-padding-left);
  box-sizing: border-box;
  z-index: 2; /* Higher than gradient overlay (z-index: 1) */
  gap: 10px;
}

/* Logo and tagline section */
.scl--web-component-footer-logo-section {
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 1497px;
  width: 100%;
}

/* Icon container */
.scl--web-component-footer-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 75px;
  flex-shrink: 0;
}

/* Logo image styling */
.scl--web-component-footer-logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Default icon (three bars) */
.scl--web-component-footer-default-icon {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 44.84px;
  height: 23px;
}

.scl--web-component-footer-icon-bar {
  width: 5.87px;
  height: 46.41px;
  background: #797979;
  border-radius: 20px;
  transform: matrix(-0.98, -0.22, 0.17, -0.99, 0, 0);
}

/* Tagline text */
.scl--web-component-footer-tagline {
  width: 100%;
  max-width: 1497px;
  font-family: var(--primary-font, 'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
  font-style: normal;
  font-size: 18px;
  font-weight: lighter;
  line-height: 150%;
  margin: 0;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 25px 50px rgba(0, 0, 0, 0.25);
  user-select: none;
  -webkit-user-select: none;
}


/* Bottom section with copyright and links */
.scl--web-component-footer-bottom {
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: end;
  align-self: center;
  gap: 20px;
  width: 100%;
  height: 100%;
  max-width: 1446px;
}

/* Copyright text */
.scl--web-component-footer-copyright {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  height: 52px;
  display: flex;
  align-items: center;
}
/* Footer links container */
.scl--web-component-footer-links {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 30px;
}

/* Individual footer link - same style as copyright */
.scl--web-component-footer-link {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  white-space: nowrap;
  
  cursor: default;
  pointer-events: none;
  user-select: none;
}

/* Remove any hover effects */
.scl--web-component-footer-link:hover,
.scl--web-component-footer-link:active,
.scl--web-component-footer-link:focus {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  outline: none;
}


/* Responsive Design */
@media screen and (max-width: 1728px) {
  .scl--web-component-footer-content {
    padding: 100px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);
  }
}

@media screen and (max-width: 1440px) {
  .scl--web-component-footer-content {
    padding: 100px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);
  }

  .scl--web-component-footer-logo-section {
    max-width: 100%;
  }

  .scl--web-component-footer-tagline {
    max-width: 100%;
  }

  .scl--web-component-footer-bottom {
    max-width: 100%;
  }
}

@media screen and (max-width: 1280px) {
  .scl--web-component-footer-content {
    padding: 200px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);
    gap: 5px;
  }

  .scl--web-component-footer-logo-section {
    align-items: center;
  }

  .scl--web-component-footer-tagline {
    text-align: center;
  }

  .scl--web-component-footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 3px;
  }

  .scl--web-component-footer-links {
    justify-content: center;
  }

  .scl--web-component-footer-copyright {
    text-align: center;
  }
    .scl--web-component-footer-link {
    line-height: 16px;
  }
}

@media screen and (max-width: 850px) {
  .scl--web-component-footer {
    width: 100%;
    max-height: 500px;

  }

  .scl--web-component-footer-content {
    max-width: 834px;
    padding: 300px var(--global-tablet-padding-left) 50px var(--global-tablet-padding-left);
    flex-direction: column;
  }

  .scl--web-component-footer-logo-section {
    max-width: 770px;
    gap: 10px;
    align-items: center;
    flex-direction: column;
  }

  .scl--web-component-footer-tagline {
    max-width: 770px;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
  }

  .scl--web-component-footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-width: 100%;
    justify-content: center;
    height: 25px;
  }

  .scl--web-component-footer-copyright {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }
  .scl--web-component-footer-links {
    gap: 20px;
    justify-content: center;
  }

  .scl--web-component-footer-link {
    font-size: 12px;
    line-height: 16px;
  }
}

@media screen and (max-width: 500px) {
  .scl--web-component-footer {
    width: 100%;
    gap: 10px;
  }

  .scl--web-component-footer-content {
    max-width: 440px;
    padding: 200px var(--global-mobile-padding-left) 61px var(--global-mobile-padding-left); /* This padding might be too much */
    gap: 5px;
  }

  .scl--web-component-footer-logo-section {
    max-width: 402px;
    gap: 0px;
    align-items: center;
    flex-shrink: 0; /* Prevent shrinking */
  }

  .scl--web-component-footer-icon-container {
    width: 52px;
    height: 52px;
    border-width: 1px;
  }

  .scl--web-component-footer-default-icon {
    width: 30.94px;
    height: 23px;
    gap: 2px;
  }

  .scl--web-component-footer-icon-bar {
    width: 3.87px;
    height: 30.61px;
  }

  .scl--web-component-footer-tagline {
    max-width: 402px;
    font-size: 22px;
    line-height: 50px;
    text-align: center;
    height: 40px;
  }

  .scl--web-component-footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-width: 402px;
    flex-shrink: 0; /* Prevent shrinking */
  }

  .scl--web-component-footer-copyright {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    max-width: 402px;
    position: relative;
    z-index: 10;
  }
   .scl--web-component-footer-links {
    gap: 10px;
    justify-content: center;
  }

  .scl--web-component-footer-link {
    font-size: 12px;
    line-height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/footer/css/footer.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;;AAGA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;;;;;;GAMC;EACD;;;;;;GAMC;AACH;AACA;EACE;;;;;;;;;;;;KAYG;AACL;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,sBAAsB;EACtB,UAAU,EAAE,8CAA8C;EAC1D,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,iBAAiB;EACjB,qGAAqG;EACrG,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,8CAA8C;EAC9C,iBAAiB;EACjB,yBAAyB;AAC3B;;;AAGA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;;EAEnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;;;EAGE,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;AACf;;;AAGA,sBAAsB;AACtB;EACE;IACE,uFAAuF;EACzF;AACF;;AAEA;EACE;IACE,uFAAuF;EACzF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uFAAuF;IACvF,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;IACE;IACA,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;;EAEnB;;EAEA;IACE,gBAAgB;IAChB,uFAAuF;IACvF,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,uFAAuF,EAAE,mCAAmC;IAC5H,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;GACC;IACC,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Footer Component Styles */\n.scl--web-component-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  max-height: 500px;\n  margin: 0 auto;\n  background: #000000;\n  overflow: hidden;\n  box-sizing: border-box;\n} \n\n\n/* Override CareerGradient positioning for footer use */\n.scl--web-component-footer .scl--svg-gradient-care {\n  position: absolute;\n  top: -1px;\n  bottom: -100px; \n  left: 0;\n  width: 100%;\n  height: calc(100% + 101px);\n  min-height: auto;\n  z-index: 0\n}\n\n.scl--web-component-footer .scl--svg-gradient-care__bg {\n  filter: blur(10px);\n  /* Mask the edges */\n  mask-image: linear-gradient(\n    to bottom,\n    transparent 0%,\n    black 5%,\n    black 95%,\n    transparent 100%\n  );\n  -webkit-mask-image: linear-gradient(\n    to bottom,\n    transparent 0%,\n    black 5%,\n    black 95%,\n    transparent 100%\n  );\n}\n.scl--web-component-footer .scl--svg-gradient-care::after {\n  background:\n    radial-gradient(\n      ellipse at center,\n      rgba(0, 0, 0, 0.2) 10%\n    ),\n    linear-gradient(\n      to top,\n      rgba(0, 0, 0, 0.199) 0%,\n      rgba(18, 8, 6, 0.45) 38%,\n      rgba(14, 6, 4, 0.75) 58%,\n      rgba(8, 3, 2, 0.92) 78%,\n      rgba(0, 0, 0, 0.98) 100%\n    );\n}\n/* Main content container */\n.scl--web-component-footer-content {\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  position: relative;\n  max-width: var(--global-desktop-width-resp);\n  width: 100%;\n  height: 100%;\n  padding: 150px var(--global-desktop-padding-left) 50px var(--global-desktop-padding-left);\n  box-sizing: border-box;\n  z-index: 2; /* Higher than gradient overlay (z-index: 1) */\n  gap: 10px;\n}\n\n/* Logo and tagline section */\n.scl--web-component-footer-logo-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  max-width: 1497px;\n  width: 100%;\n}\n\n/* Icon container */\n.scl--web-component-footer-icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 75px;\n  flex-shrink: 0;\n}\n\n/* Logo image styling */\n.scl--web-component-footer-logo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Default icon (three bars) */\n.scl--web-component-footer-default-icon {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 44.84px;\n  height: 23px;\n}\n\n.scl--web-component-footer-icon-bar {\n  width: 5.87px;\n  height: 46.41px;\n  background: #797979;\n  border-radius: 20px;\n  transform: matrix(-0.98, -0.22, 0.17, -0.99, 0, 0);\n}\n\n/* Tagline text */\n.scl--web-component-footer-tagline {\n  width: 100%;\n  max-width: 1497px;\n  font-family: var(--primary-font, 'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);\n  font-style: normal;\n  font-size: 18px;\n  font-weight: lighter;\n  line-height: 150%;\n  margin: 0;\n  color: rgba(255, 255, 255, 1);\n  text-shadow: 0px 25px 50px rgba(0, 0, 0, 0.25);\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n\n/* Bottom section with copyright and links */\n.scl--web-component-footer-bottom {\n  display: flex;\n  flex-direction: row;\n  align-items: end;\n  justify-content: end;\n  align-self: center;\n  gap: 20px;\n  width: 100%;\n  height: 100%;\n  max-width: 1446px;\n}\n\n/* Copyright text */\n.scl--web-component-footer-copyright {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.6);\n  white-space: nowrap;\n  height: 52px;\n  display: flex;\n  align-items: center;\n}\n/* Footer links container */\n.scl--web-component-footer-links {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px;\n  gap: 30px;\n}\n\n/* Individual footer link - same style as copyright */\n.scl--web-component-footer-link {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  white-space: nowrap;\n  \n  cursor: default;\n  pointer-events: none;\n  user-select: none;\n}\n\n/* Remove any hover effects */\n.scl--web-component-footer-link:hover,\n.scl--web-component-footer-link:active,\n.scl--web-component-footer-link:focus {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  outline: none;\n}\n\n\n/* Responsive Design */\n@media screen and (max-width: 1728px) {\n  .scl--web-component-footer-content {\n    padding: 100px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .scl--web-component-footer-content {\n    padding: 100px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);\n  }\n\n  .scl--web-component-footer-logo-section {\n    max-width: 100%;\n  }\n\n  .scl--web-component-footer-tagline {\n    max-width: 100%;\n  }\n\n  .scl--web-component-footer-bottom {\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .scl--web-component-footer-content {\n    padding: 200px var(--global-laptop-padding-left) 50px var(--global-laptop-padding-left);\n    gap: 5px;\n  }\n\n  .scl--web-component-footer-logo-section {\n    align-items: center;\n  }\n\n  .scl--web-component-footer-tagline {\n    text-align: center;\n  }\n\n  .scl--web-component-footer-bottom {\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n  }\n\n  .scl--web-component-footer-links {\n    justify-content: center;\n  }\n\n  .scl--web-component-footer-copyright {\n    text-align: center;\n  }\n    .scl--web-component-footer-link {\n    line-height: 16px;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .scl--web-component-footer {\n    width: 100%;\n    max-height: 500px;\n\n  }\n\n  .scl--web-component-footer-content {\n    max-width: 834px;\n    padding: 300px var(--global-tablet-padding-left) 50px var(--global-tablet-padding-left);\n    flex-direction: column;\n  }\n\n  .scl--web-component-footer-logo-section {\n    max-width: 770px;\n    gap: 10px;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .scl--web-component-footer-tagline {\n    max-width: 770px;\n    font-size: 22px;\n    line-height: 150%;\n    text-align: center;\n  }\n\n  .scl--web-component-footer-bottom {\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n    max-width: 100%;\n    justify-content: center;\n    height: 25px;\n  }\n\n  .scl--web-component-footer-copyright {\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n  }\n  .scl--web-component-footer-links {\n    gap: 20px;\n    justify-content: center;\n  }\n\n  .scl--web-component-footer-link {\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .scl--web-component-footer {\n    width: 100%;\n    gap: 10px;\n  }\n\n  .scl--web-component-footer-content {\n    max-width: 440px;\n    padding: 200px var(--global-mobile-padding-left) 61px var(--global-mobile-padding-left); /* This padding might be too much */\n    gap: 5px;\n  }\n\n  .scl--web-component-footer-logo-section {\n    max-width: 402px;\n    gap: 0px;\n    align-items: center;\n    flex-shrink: 0; /* Prevent shrinking */\n  }\n\n  .scl--web-component-footer-icon-container {\n    width: 52px;\n    height: 52px;\n    border-width: 1px;\n  }\n\n  .scl--web-component-footer-default-icon {\n    width: 30.94px;\n    height: 23px;\n    gap: 2px;\n  }\n\n  .scl--web-component-footer-icon-bar {\n    width: 3.87px;\n    height: 30.61px;\n  }\n\n  .scl--web-component-footer-tagline {\n    max-width: 402px;\n    font-size: 22px;\n    line-height: 50px;\n    text-align: center;\n    height: 40px;\n  }\n\n  .scl--web-component-footer-bottom {\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n    max-width: 402px;\n    flex-shrink: 0; /* Prevent shrinking */\n  }\n\n  .scl--web-component-footer-copyright {\n    font-size: 12px;\n    line-height: 16px;\n    text-align: center;\n    max-width: 402px;\n    position: relative;\n    z-index: 10;\n  }\n   .scl--web-component-footer-links {\n    gap: 10px;\n    justify-content: center;\n  }\n\n  .scl--web-component-footer-link {\n    font-size: 12px;\n    line-height: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
